module.exports = __webpack_public_path__ + "static/media/BW.63351ba4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BW.svg
// module id = 2121
// module chunks = 7